//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import interceptBackButton from '../intercept-back-button.js';
  import {
    archiveItems,
    unarchiveItems,
    bulkDelete,
  } from '../db-utils.js';
  import {exportToCalendar} from '../gcalendar-utils.js'
import { fromMatchingDb } from "../utils.js";
import SelectedDateMenu from './selected-date-menu.vue';
import {
  removePlannedFor,
  bulkNestAtEnd,
  bulkRescheduleAtEnd,
} from '../ordered-relation';

  export default {
    props: {
      task: Object,
      buttonClass: [String, Object],
    },
    data() {
      return {
        dateMenu: false,
        listMenu: false,
        menuOpen: false,
        backdropEl: null,
        clearBackButtonHandler: null,
        showDeleteDialog: false,
      };
    },
    components: {
      SelectedDateMenu,
    },
    computed: {
      allIds() {
        if (!this.$taskCardsController ||
            !this.$taskCardsController.selectedTasksIds) {
          return [];
        }
        return Object.keys(this.$taskCardsController.selectedTasksIds);
      },
      selectedTasks() {
        return this.$taskCardsController.selectedTasks();
      },
      selectedAreAllArchived() {
        for (const task of this.selectedTasks) {
          if (!task.archivedTimestampMs) {
            return false
          }
        }
        return true;
      },
      selectedCouches() {
        const couches = this.selectedTasks.map(item => item.couch)
        return [...new Set(couches)]
      },
    },
    methods: {
      fromMatchingDb,
      exportSelected() {
        for (const task of this.selectedTasks) {
          if (task.plannedFor && task.plannedFor.parentClass === 'day') {
            exportToCalendar(task);
          }
        }
        this.$root.$emit('snackbar', {msg: "Items exported to Google Calendar"});
      },
      attachSelected() {
        this.$taskCardsController.startAttachingSelection();
      },
      archiveSelected() {
        archiveItems(this.selectedTasks, this);
        this.$taskCardsController.leaveSpecialState();
      },
      unarchiveSelected() {
        unarchiveItems(this.selectedTasks)
        this.$taskCardsController.leaveSpecialState();
      },
      deleteSelected() {
        bulkDelete(this.selectedTasks)
        this.$taskCardsController.leaveSpecialState();
      },
      moveSelected(listID) {
        bulkNestAtEnd({
          reactiveCache: this.$reactiveCache,
          tasks: this.selectedTasks,
          newPPtr: {parentClass: 'list', parentKey: listID},
        })
      },
      onOpened() {
        this.showBackdrop();
        this.clearBackButtonHandler = interceptBackButton(() => {
          this.menuOpen = false;
        });
      },
      onClosed() {
        if (this.clearBackButtonHandler) {
          this.clearBackButtonHandler();
          this.clearBackButtonHandler = null;
        }
        this.removeBackdrop();
      },
      showBackdrop() {
        if (!this.backdropEl) {
          this.backdropEl = document.createElement('div');
          this.backdropEl.classList.add('selection-actions-menu-backdrop');
          document.body.appendChild(this.backdropEl);
        }
      },
      removeBackdrop() {
        if (this.backdropEl) {
          this.backdropEl.remove();
          this.backdropEl = null;
        }
      },
    },
    beforeDestroy() {
      this.onClosed();
    },
  };
